import {
  useCallback,
  useMemo,
  //  useRef
  useState,
} from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';

import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import DataTable from 'src/components/DataTable';

import { useGetCandidateShifts } from 'src/pages/CandidatesDetailsPage/api';
import { forceString, timeFormat } from 'src/utils/datetime';
// import SearchFilterBar, {
//   QuickFiltersType,
// } from 'src/components/SearchFilterBar';
import JobLink from 'src/components/JobLink';

import messages from './messages';
import ProjectLink from 'src/components/ProjectLink';

export interface CandidateTabProps {
  id?: string;
  uuid?: string;
  candidate?: UCM.Candidate;
}

export default function CandidateShiftsTab({ uuid }: CandidateTabProps) {
  const { formatMessage } = useIntl();

  // const [searchFilters, setSearchFilters] = useState<Record<string, string>>(
  //   {},
  // );
  const [params, setParams] = useState<Record<string, string | number>>({
    page: 1,
  });

  // TODO - temporary solution to get candidate shifts with filtering
  const { data, isLoading } = useGetCandidateShifts({
    uuid: uuid!,
    params,
    enabled: Boolean(uuid),
  });

  // const quickFilters: Array<QuickFiltersType> = useRef([
  //   {
  //     autoFocus: true,
  //     id: 'quick_search',
  //     type: 'text' as QuickFiltersType['type'],
  //     placeholder: formatMessage(messages.searchInputPlaceholder),
  //   },
  // ]).current;

  const columns: Array<{
    id: string;
    label: string;
  }> = useMemo(
    () => [
      {
        id: 'jobId',
        label: formatMessage(messages.jobIdColumnLabel),
        render: (_: unknown, { project, job }: UCM.CandidateShiftsType) => (
          <JobLink jobId={job.id} projectUuid={project.uuid} target="_blank" />
        ),
        align: 'center',
      },
      {
        id: 'jobName',
        label: formatMessage(messages.jobNameColumnLabel),
        render: (_: unknown, { job }: UCM.CandidateShiftsType) => (
          <Typography variant="inherit">{job.title}</Typography>
        ),
      },
      {
        id: 'projectName',
        label: formatMessage(messages.projectNameColumnLabel),
        render: (_: unknown, { project }: UCM.CandidateShiftsType) => (
          <ProjectLink
            projectUuid={project.uuid}
            label={`${project.id} - ${project.name}`}
            target="_blank"
          />
        ),
      },
      {
        id: 'dateRangeAndTime',
        label: formatMessage(messages.dateRangeAndTimeColumnLabel),
        render: (_: unknown, item: UCM.CandidateShiftsType) => {
          const isSameDay = moment(item.shiftStartsAt).isSame(
            moment(item.shiftEndsAt),
            'day',
          );
          return (
            <>
              <Typography variant="inherit">
                {isSameDay
                  ? forceString(item.shiftStartsAt)
                  : [
                      forceString(item.shiftStartsAt),
                      forceString(item.shiftEndsAt),
                    ].join(' - ')}
              </Typography>
              <Typography variant="inherit">
                {[
                  forceString(item.shiftStartsAt, timeFormat),
                  forceString(item.shiftEndsAt, timeFormat),
                ].join(' - ')}
              </Typography>
            </>
          );
        },
        align: 'center',
      },
      {
        id: 'jobType',
        label: formatMessage(messages.jobTypeColumnLabel),
        render: (_: unknown, { job }: UCM.CandidateShiftsType) => (
          <Typography variant="inherit">{job.type}</Typography>
        ),
        align: 'center',
      },
      {
        id: 'rating',
        label: formatMessage(messages.ratingColumnLabel),
        render: (_: unknown, { userJobRating }: UCM.CandidateShiftsType) => (
          <Typography variant="inherit">{userJobRating ?? '-'}</Typography>
        ),
        align: 'center',
      },
    ],
    [],
  );

  // eslint-disable-next-line
  // const handleSearch = useCallback((filters: Record<string, any>) => {
  //   setSearchFilters(filters);
  // }, []);

  const handlePagination = useCallback((_: unknown, page: number) => {
    setParams({ page: page + 1 });
  }, []);

  return (
    <Grid container spacing={2} p={2}>
      {/* <Grid size={4}>
        <SearchFilterBar fields={quickFilters} onSearch={handleSearch} />
      </Grid> */}

      <DataTable
        rows={data?.data}
        columns={columns}
        loading={isLoading}
        pagination={data?.meta}
        onPaginate={handlePagination}
      />
    </Grid>
  );
}
